<template lang="html">
  <div class="regLoginHeader row">
    <div class="col-sm-12 nav">
      <span @click="showNav"><img class="img-responsive" src="../assets/img/icons/menu-icon.svg" width="640" height="360" alt="Logo"></span>
      <div v-if="nav" class="nav-container">
        <div class="hideNav text-left">
          <span @click="hideNav"><img class="img-responsive" src="../assets/img/icons/menu-icon-blue.svg" width="640" height="360" alt="Logo"></span>
        </div>
        <div class="links">
          <router-link :to="{name:'about-us', params:{ lang: lang}}">{{translation.aboutUs.about}}</router-link>
        </div>
        <div class="links">
          <router-link :to="{name:'support', params:{ lang: lang}}">{{translation.header.contacts}}</router-link>
        </div>
        <div class="links language-mobile">
          <select id="select-language" v-model="defaultLang" @change="setLanguage">
            <option class="language-option" v-for="language in languages" :value="language.value">
              {{language.text}}
            </option>
          </select>
        </div>
        <div class="links registration">
          <router-link :to="{name:'registration', params:{ lang: lang}}">{{translation.header.registration}}</router-link>
        </div>
        <div class="links login">
          <router-link :to="{name:'login', params:{ lang: lang}}">{{translation.header.login}}</router-link>
        </div>
        <div class="left-paw">
          <img class="img-responsive" src="../assets/img/icons/small-menu-left-paw.svg" alt="Paw">
        </div>
        <div class="right-paw">
          <img class="img-responsive" src="../assets/img/icons/small-menu-right-paw.svg" alt="Paw">
        </div>
        <div class="links center-paw">
          <img class="img-responsive" src="../assets/img/icons/one-paw-mobile.svg" alt="Paw">
        </div>
        <div class="links followUs">
          {{translation.menu.followUs}}
        </div>
        <div class="followUs-icons">
          <div class="row">
            <div class="col-xs-6 fb text-right">
              <a href="https://web.facebook.com/My-Electronic-Pet-Passport-100922267942159" target="_blank"><img class="img-responsive" src="../assets/img/icons/facebook-blue.svg" alt="Facebook"></a>
            </div>
            <div class="col-xs-6 insta text-left">
              <a href="https://www.youtube.com/channel/UCQslSWc0OMv5CabwZ5d8McQ" target="_blank"><img class="img-responsive" src="../assets/img/icons/YouTube_social_dark.svg" alt="Instagram"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 middle">
      <div class="row">
        <div class="col-sm-4 logo">
          <router-link :to="{name:'home', params:{ lang: lang}}"><img class="img-responsive" src="../assets/img/icons/white-logo.svg" width="640" height="360" alt="Logo"></router-link>
        </div>
        <div class="col-sm-7">
          <span class="registration-text" v-if="urlPath == 'registration'">
            {{translation.registration.haveRegistartion}}
            <router-link class="btn-border" :to="{name:'login', params:{ lang: lang}}">{{translation.header.login}}</router-link>
          </span>
          <span class="login-text" v-else-if="urlPath == 'login' || urlPath == 'reset-password'">
            {{translation.registration.noRegistration}}
            <router-link class="btn-border"  :to="{name:'registration', params:{ lang: lang}}">{{translation.header.registration}}</router-link>
          </span>
        </div>
        <div class="col-sm-1 language">
          <select id="select-language" v-model="defaultLang" @change="setLanguage">
            <option class="language-option" v-for="language in languages" :value="language.value">
              {{language.text}}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegLoginHeader',
  data(){
    return {
      translation: message,
      nav: false,
      lang: window.lang,
      languages: message.flags.flag,
      defaultLang: '',
      urlPath: null,
      loader: false,
      user: [],
      pets:'',
      doctor: [],
      defaultLang: ''
    }
  },
  created(){
    console.log('#regLoginApp app');
    if (localStorage.getItem('language')) {
      this.defaultLang = localStorage.getItem('language');
    }else {
      this.defaultLang = 'bg_BG';
    }
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    if (this.$route.name == 'registration') {
      this.urlPath = this.$route.name;
    }else if(this.$route.name == 'login'){
      this.urlPath = this.$route.name;
    }else if(this.$route.name == 'reset-password'){
      this.urlPath = this.$route.name;
    }
  },
  methods: {
    showNav: function(e){
      this.nav = true;
    },
    hideNav: function(e){
      this.nav = false;
    },
    setLanguage: function(){
      localStorage.setItem('language', this.defaultLang);
      this.$bus.$emit('language',true)
    }
  }
}
</script>

<style lang="css" scoped>
.regLoginHeader {
  margin-top: 2em;
  position: relative;
}
.regLoginHeader .language {
  text-align: left;
}
.regLoginHeader .language select,
.regLoginHeader .language-mobile select{
  border: none;
  background: none;
  border-radius: 5em;
  padding: 5px;
  color: #FDD84C;
  font-family: 'Montserrat-Bold', sans-serif;
  border: none;
  outline: none;
  scroll-behavior: smooth;
}
.logo .router-link-active img {
  width: 10em;
}
.regLoginHeader .language-mobile select{
  background: #3057B0;
  color: #FFFFFF;
}
.language-option{
  color:#3057B0;
  background-color: #FDD84C;
}
.regLoginHeader .language select::-ms-expand,
.regLoginHeader .language-mobile select::-ms-expand {
    display: none;
}
.regLoginHeader .language select,
.regLoginHeader .language-mobile select{
    -webkit-appearance: none;
    appearance: none;
}

.back{
  margin-right: 0;
  padding-right: 0!important;
}
.ballon{
  display: inline-block;
  position: absolute;
  top: -2em;
  width: 140px;
  left:0;
  right:0;
  margin-left:auto;
  margin-right:auto;
}
.regLoginHeader .back img {
  display: inline-block;
  position: absolute;
  top: -2em;
  right: -15px;
  width: 120px;
}
.nav-container{
  position: fixed;
  width: 100%;
  max-height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 999;
  overflow-y: scroll;
}
.regLoginHeader .links{
  margin-bottom: 1em;
  text-align: center;
  font-family: 'Montserrat-Bold', sans-serif;
}
.regLoginHeader .links a{
  color: #3057B0;
}
.regLoginHeader .registration a{
  color: #FFF;
}
.regLoginHeader .login a{
  color: #3057B0!important;
}
.regLoginHeader .registration{
  background: #3057B0;
  border-radius: 5em;
  padding: 5px;
  width: 70%;
  margin: 0 auto;
  margin-bottom: 1em;
}
.regLoginHeader .registration-text .btn-border,
.regLoginHeader .login-text .btn-border {
  padding: .3em;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border-radius: 5em;
  border: 2px solid #FFF;
  color: #FFFFFF;
}
.regLoginHeader .login-text .btn-border {
  background: #FDD84C;
  border: 2px solid #FDD84C;
  color: #3057B0;
}
.regLoginHeader .login{
  border-radius: 5em;
  padding: 5px;
  width: 50%;
  margin: 0 auto;
  border: 2px solid #3057B0;
}
.nav{
  display: none;
}
.regLoginHeader a.router-link-active {
   color: #fff;
}
.registration-text,
.login-text{
  color: #fff;
  font-size: 1em;
  font-family: 'Montserrat-Bold', sans-serif;
}
.footer .footer-menu,
.footer .copyRights{
  text-align: center;
}
.nav{
  text-align: left;
}
@media (max-width: 768px) {
  .middle{
    display: none;
  }
  .ballon{
    display: none;
  }
  .followUs{
    margin-top: 2em;
  }
  .nav{
    display: block;
  }
  .language{
    display: none;
  }
  .regLoginHeader {
    margin-top: 1em;
  }
  .regLoginHeader .back img {
    top: -1em;
  }
  .logo {
    margin: 0 auto;
  }
  .regLoginHeader span img {
    width: 5em;
  }
  .hideNav{
    padding: 15px;
  }
  .regLoginHeader .links{
    margin-bottom: 1em;
  }
  .regLoginHeader .right-paw{
    position: absolute;
    right: 0;
    top: 7em;
  }
  .regLoginHeader .left-paw{
    position: absolute;
    left: 0;
    top: 14em;
  }
  .regLoginHeader .registration a{
    border: none;
    border-radius: 5em;
    padding: 5px;
    width: 70%;
    margin: 0 auto;
  }
  .regLoginHeader .login-text a{
    color: #FFF;
  }
  .regLoginHeader .center-paw {
    display: none;
  }
 }
 @media (max-width: 600px) {
   .logo{
     margin-left: 1em;
   }
   .regLoginHeader .links{
     font-size: 1.2em;
     margin-bottom: 1em;
   }
   .regLoginHeader .center-paw {
     bottom: 28%;
   }

 }
</style>
